var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toast',{attrs:{"text":_vm.text,"time":_vm.options.duration || 2000},model:{value:(_vm.showToast),callback:function ($$v) {_vm.showToast=$$v},expression:"showToast"}})
}
var staticRenderFns = []

export { render, staticRenderFns }